import React from "react";
import TicketForm from "../../components/TicketForm";

export default function ChamadoManutencao() {
  return (
    <TicketForm
      tipo="manutencao"
      title="Solicitar manutenção"
      subtitle="Descreva o problema. Nossa oficina entra em ação."
      motivos={[
        "Roda danificada",
        "Estrutura amassada / quebrada",
        "Problema no freio",
        "Barulho ao usar",
      ]}
      showUrgencia
      showFoto
    />
  );
}
